// test254
(254 && 0);
